import { render } from "./GenAI.vue?vue&type=template&id=6498053c"
import script from "./GenAI.vue?vue&type=script&lang=js"
export * from "./GenAI.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__